import { determineFullTradeData } from "@/lib/agGridColDefs/colDefGlobalHelpers";
import tradeDataStore from "@/store/tradeDataStore";
import { formatCouponWithNotation } from "./couponActionSummarySwapFormatter";

const CouponActionSummarySwapCellRenderer = (params: any) => {
  const fullTradeData = determineFullTradeData(params);

  // Subscribe to Zustand for reactive updates, fallback to fullTradeData for historical trades
  const currentTradeData = tradeDataStore((state) => state.tradeData);
  const thisTrade =
    currentTradeData.find((trade) => trade.esid == fullTradeData.esid) ??
    fullTradeData;

  // Use formatting with notation for display
  const formattedValue = formatCouponWithNotation(params, thisTrade);

  if (!formattedValue) {
    return null;
  }

  return (
    <div data-testid="couponActionSummarySwapCellContainer">
      {formattedValue}
    </div>
  );
};

export default CouponActionSummarySwapCellRenderer;
